var render = function render(){var _vm=this,_c=_vm._self._c;return _c('MenuGroup',{attrs:{"title":_vm.menu.text}},[_vm._l((_vm.menu.children),function(item2,index2){return [(item2.children&&item2.children.length>0)?[_c('sideBarItem',{attrs:{"menu":item2}})]:[_c('MenuItem',{attrs:{"name":item2.name}},[(item2.icon)?_c('i',{class:item2.icon}):_vm._e(),_c('span',[_vm._v(_vm._s(item2.text))])])]]})],2)
}
var staticRenderFns = []

export { render, staticRenderFns }